import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("ErrorBoundary caught:", error);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#09090B] text-[#FAFAFA] p-6" data-testid="error-boundary-fallback">
          <div className="max-w-sm text-center">
            <h2 className="font-display text-2xl font-medium tracking-tight mb-2">Algo salio mal</h2>
            <p className="text-[#A1A1AA] text-sm mb-6">Ocurrio un error inesperado. Recarga la pagina para continuar.</p>
            <button
              onClick={this.handleReload}
              data-testid="error-boundary-reload-button"
              className="h-11 px-6 rounded-md bg-[#5E6AD2] hover:bg-[#4B55C3] text-white text-sm transition-colors"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
